export { FavoritesCardsMobile } from './cards';
